import { mode } from "@chakra-ui/theme-tools";

const Card = {
  baseStyle: (props) => ({
    p: "22px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxShadow: "0px 5px 14px rgba(0, 0, 0, 0.05)",
    borderRadius: "20px",
    position: "relative",
    wordWrap: "break-word",
    bg: mode("white", "gray.700")(props),
    backgroundClip: "border-box",
  }),
  variants: {
    panel: (props) => ({
      bg: mode("white", "gray.700")(props),
      border: `1px solid ${mode("gray.200", "gray.600")(props)}`,
    }),
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
